import type { LinkProps } from 'next/dist/client/link';
import type { TransitionComponentProps } from '../react-transition-component/types/transitionComponent.types';

export const buttonType = ['button', 'submit'] as const;
export const linkTarget = ['_self', '_blank'] as const;

export type ButtonType = (typeof buttonType)[number];
export type LinkTarget = (typeof linkTarget)[number];

export const defaultTarget: AbstractCtaProps['target'] = '_self';
export const defaultType: AbstractCtaProps['type'] = 'button';
export const defaultDisabled: AbstractCtaProps['disabled'] = false;

export type CtaRefType = HTMLAnchorElement | HTMLButtonElement;

export type AbstractCtaProps = {
  onClick?: (e?: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => void;
  onMouseEnter?: () => void;
  onMouseLeave?: () => void;

  className?: string;
  disabled?: boolean;

  'aria-label'?: string;

  'aria-pressed'?: 'true' | 'false';
  title?: string;
  label?: string | number;
  // children: ReactNode;

  forceTag?: 'div' | 'span';
  iconOnHover?: boolean;

  id?: string;
  rel?: string;
  type?: ButtonType;
  target?: LinkTarget;
  link?: LinkProps & {
    uuid?: string;
    href?: string;
  };
} & TransitionComponentProps;
